import styled from 'styled-components';

export const ProcessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > p {
    margin-bottom: 0;
    margin-top: 20px;
  }
`;

export const Error = styled.p`
  color: #D83430 !important;
  font-size: 10px !important;
  text-align: left !important;
  height: 10px;
  margin: 0 0 10px 0;
`;